module.exports = __webpack_public_path__ + "img/Truce_Logo.11f791b4.png";